module.exports = __webpack_public_path__ + "img/Frame_03.c1b00d9c.png";